//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, watch } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@core/utils/useCryptoJs'

export default {
  name: 'DownloadApp',
  model: {
    prop: 'isOpen',
    event: 'update:is-open',
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    closeTime: {
      type: Number,
      default: 10000,
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const { userData } = useCryptoJs()

    const computedIsOpen = computed({
      set: val => emit('update:is-open', val),
      get: () => props.isOpen,
    })

    const onSave = () => {
      emit('save')
    }

    watch([computedIsOpen], () => {
      if (computedIsOpen.value) {
        setTimeout(() => {
          computedIsOpen.value = false
        }, props.closeTime)
      }
    })

    return {
      // data
      userData,

      // computed
      computedIsOpen,

      // methods
      onSave,

      // i18n
      t,

      // icons
      icons: {
        mdiClose,
      },
    }
  },
}
